<template>
  <div class="footer">
    <div class="footer_top" v-if="false">
      <div class="main">
        <ul>
          <li>
            <dl>
              <dt><img src="@/assets/images/footer_ico1.png">购物指南</dt>
              <dd><a href="">购物流程</a></dd>
              <dd><a href="">新用户注册</a></dd>
              <dd><a href="">预存款支付</a></dd>
              <dd><a href="">退换货政策</a></dd>
              <dd><a href="">订单查询</a></dd>
            </dl>
          </li>
          <li>
            <dl>
              <dt><img src="@/assets/images/footer_ico2.png"/>配送方式</dt>
              <dd><a href="">配送费收费标准</a></dd>
            </dl>
          </li>
          <li>
            <dl>
              <dt><img src="@/assets/images/footer_ico3.png"/>支付方式</dt>
              <dd><a href="">银行卡支付</a></dd>
              <dd><a href="">支付宝支付</a></dd>
              <dd><a href="">微信支付</a></dd>
            </dl>
          </li>
          <li>
            <dl>
              <dt><img src="@/assets/images/footer_ico4.png"/>XX服务</dt>
              <dd><a href="">安全卫士</a></dd>
              <dd><a href="">门店查询</a></dd>
              <dd><a href="">仓库查询</a></dd>
            </dl>
          </li>
          <li>
            <dl>
              <dt><img src="@/assets/images/footer_ico5.png"/>售后保障</dt>
              <dd><a href="">发票保障</a></dd>
              <dd><a href="">售后服务</a></dd>
              <dd><a href="">温馨提示</a></dd>
            </dl>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer_bottom">
      <div class="main">
        <p>{{ bottom_copyright.companyName }} 电话：{{ bottom_copyright.telephone }}</p>
        <p>{{ bottom_copyright.filingNumber }} {{ bottom_copyright.copyright }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {getDictItems} from '../../api/login'

export default {
  name: 'footerBar',
  data () {
    return {
      bottom_copyright: {}
    }
  },
  mounted () {
    getDictItems({dictCode: 'bottom_copyright'}).then(response => {

      let bottom_copyright = {}
      response.forEach((item) => {
        bottom_copyright[item.title] = item.value
      })
      this.bottom_copyright = bottom_copyright
    })
  },
}
</script>

<style scoped>
@import "../../assets/style/index.css";

</style>



// WEBPACK FOOTER //
// src/components/footer/footerBar.vue